import { useEffect, useState } from 'react';
import {
  getPantoneAuthState,
  PantoneAuthState,
  startLogin,
  completeLogin,
  logout,
  revokeAccess,
  acceptLicense,
  hasAcceptedLicense,
  refreshTokenIfNeeded,
  subscribe,
} from '../lib/pantoneAuth';

export function usePantoneAuth() {
  const [state, setState] = useState<PantoneAuthState>(() => getPantoneAuthState());

  useEffect(() => {
    return subscribe(setState);
  }, []);

  return {
    state,
    login: startLogin,
    logout,
    revokeAccess,
    acceptLicense,
    hasAcceptedLicense,
    refreshTokenIfNeeded,
    completeLogin,
  } as const;
}
